<template>
    <el-card>
        <div slot="header">
            <span class="top_title">采购退货单</span>
        </div>
        <div class="searchItem">
            <div class="search">
                <span class="searchtips">日期:</span>
                <el-date-picker
                    v-model="searchDate.dateRan"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 230px"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </div>
            <div class="search">
                <span class="searchtips">退货单号:</span>
                <el-input v-model="searchDate.purid" placeholder="" style="width: 160px;"></el-input>
            </div>
            <div class="search">
                <span class="searchtips">供应商:</span>
                <el-select v-model="searchDate.slid" clearable style="width:160px">
                    <el-option v-for="item in supplyList" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
            </div>
            <div class="search">
                <span class="searchtips">备注:</span>
                <el-input v-model="searchDate.remark" placeholder="" style="width: 160px;"></el-input>
            </div>
            <div class="search">
                <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
            </div>
            <div class="search">
                <el-button
                    type="primary"
                    icon="el-icon-printer"
                    @click="print"
                    v-if="$common.checkWindowsEnv()"
                    >打印</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-document"
                    @click="changePdf"
                >导出</el-button>
            </div>
        </div>
        <div style="display:flex;justify-content: flex-end;">
            <el-button split-button type="primary" @click="edit(0)" v-if="$common.hasLimits('materialReturnAdd')">新增</el-button>
        </div>
        <el-table
            :data="tableData"
            style="
                width: 100%;
                margin-top: 20px;
                margin-bottom: 20px;
            "
            border
            show-summary
            :summary-method="getSummaries"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="操作" width="200px" align="center">
                <template slot-scope="{row}">
                    <el-button type="text" @click="edit(row.id)" v-if="$common.hasLimits('materialReturnDetailEdit')">编辑</el-button>
                    <el-button type="text" @click="del(row.id)" v-if="$common.hasLimits('materialReturnDetailDelete')">删除</el-button>
                </template>
            </el-table-column>
            <template v-for="(col, index) in cols">
                <template v-if="col.show">
                    <el-table-column :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align">
                        <template #header v-if="col.column">
                            {{col.label}}
                            <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                            <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                        </template>
                    </el-table-column>
                </template>
            </template>
        </el-table>
            <el-pagination
            style="text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 120, 250]"
            :page-size="cp_pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
        >
        </el-pagination>
        <ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
    </el-card>
</template>
<script>
import ReportOrder from '../../components/printshare/reportorder.vue';
import editShare from '../../components/printshare/edit_share';
export default {
    components:{
        ReportOrder,
        editShare,
    },
    data(){
        return{
            searchDate: {
                dateRan: "",
                purid:"",
                remark:"",
                slid:"",
                wareid:'',
                column:'',
				order:'',
            },
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            cols:[
                {
                prop: 'number',
                label: '采购单号',
                width: '180',
                show: true,
                align:'left',
                column:'number',
            },{
                prop: 'money',
                label: '总金额(元)',
                width: '180',
                show: true,
                align:'left',
                column:'money',
            },{
                prop: 'supplyName',
                label: '供应商',
                width: '180',
                show: true,
                align:'left',
                column:'supply',
            },{
                prop: 'wname',
                label: '出库仓库',
                width: '180',
                show: true,
                align:'left',
                column:'wid',
            },{
                prop: 'ename',
                label: '经办人',
                width: '180',
                show: true,
                align:'left',
                column:'eid',
            },{
                prop: 'remark',
                label: '备注',
                width: '180',
                show: true,
                align:'left',
            },{
                prop: 'date',
                label: '创建日期',
                width: 180,
                show: true,
                align:'left',
                column:'cdate',
            }],
            tableData:[],
            total:0,
            currentPage:1,
            cp_pagesize:20,
            supplyList:[],
            listWare:[],
            nowSearch:{
                limit:20,
                page:1,
            },
            moneySum:0,
            multipleSelection:[],
        }
    },
    created(){
        this.$api.listSupply().then(res=>{
            if(res.data.code==1){
                res.data.data.data.forEach(e => {
                    let obj = {
                        id:e.id,
                        label:"["+e.number+"]"+e.name,
                    }
                    this.supplyList.push(obj);
                });
            }
        })
        this.$api.mListWare().then(res=>{
            if(res.data.code==1){
                res.data.data.data.forEach(e => {
                    let obj = {
                        id:e.id,
                        label:e.name+e.remark,
                    }
                    this.listWare.push(obj);
                });
            }
        })
        this.getInfo();
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        getSummaries(){
            return [,'合计',,this.moneySum];
        },
        print(){
            if(this.multipleSelection.length>0){
                let array = [];
                this.multipleSelection.forEach(e=>{
                    array.push(e.id);
                })
                this.$nextTick(()=>{
                    this.$refs.roder.extraOpen(15,array);
                })
            }else{
                this.$common.error("没有选择采购单");
            }
        },
        changePdf(){
            if(this.multipleSelection.length>0){
                let array = [];
                this.multipleSelection.forEach(e=>{
                    array.push(e.id);
                })
                this.$nextTick(()=>{
                    this.$refs.share.openList(array,15);
                })
            }else{
                this.$common.error("没有选择采购单");
            }
        },
        searchOrder(){
            this.currentPage = 1;
            this.nowSearch = {
                limit:this.cp_pagesize,
                page:1,
            }
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.nowSearch.start = this.searchDate.dateRan[0];
                this.nowSearch.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.purid.length>0){
                this.nowSearch.number = this.searchDate.purid;
            }
            if(this.searchDate.slid>0){
                this.nowSearch.supply = this.searchDate.slid;
            }
            if(this.searchDate.wareid>0){
                this.nowSearch.wid = this.searchDate.wareid;
            }
            if(this.searchDate.remark.length>0){
                this.nowSearch.remark = this.searchDate.remark;
            }
            this.sortTime();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.nowSearch.column = this.searchDate.column;
                this.nowSearch.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.nowSearch.column;
                delete this.nowSearch.order;
            }
            this.getInfo();
        },
        getInfo(){
            this.$api.listReturn(this.nowSearch).then(res=>{
                if(res.data.code==1){
                    this.tableData = res.data.data.data;
                    this.total = res.data.data.total;
                    this.moneySum = res.data.data.moneySum;
                }
            })
        },
        handleSizeChange(e){
            this.cp_pagesize = e;
            this.searchOrder();
        },
        handleCurrentChange(e){
            this.currentPage = e;
            this.nowSearch.page = e;
            this.getInfo();
        },
        edit(id){
            if(!id){
                id = 0;
            }
            this.$router.push({ 
                path: "/refundAdd",
                query:{id:id},
            })
        },
        del(id){
            if(!id){
                return;
            }
            this.$api.deleteReturn({deleteId:id}).then(res=>{
                if(res.data.code==1){
                    if(this.tableData.length==1&&this.currentPage>1){
                        this.currentPage = 1;
                    }
                    this.$notify({
                        title: "删除采购退货单",
                        message: "删除成功",
                        type: "success",
                        duration: 1000,
                    });
                    this.getInfo();
                }
            })
        },
    }
}
</script>

<style scoped>

</style>